/**
 * <bc-crash> replays the footer sign's fall. The page renders the sign already crashed; this hangs it level a
 * screen before it scrolls in, then drops it once the spot it will hit is on screen. All timing lives in the CSS
 * animations. At the moment the corner hits the floor it sends `bc:startle` so the bugs on the wall scatter.
 */
class BcCrash extends HTMLElement {
  connectedCallback() {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const stage = this.querySelector('.bc-crash__stage');
    const sign = this.querySelector('.bc-crash__sign');
    const corner = this.querySelector('.bc-crash__corner');
    const impact = this.querySelector('.bc-crash__impact');

    // The fall animation ends exactly when the corner meets the floor; the bounce, cracks and dust start there too.
    sign.addEventListener('animationend', (event) => {
      if (event.animationName !== 'bc-crash-fall') return;
      const { left: x, top: y } = corner.getBoundingClientRect();
      sign.dispatchEvent(new CustomEvent('bc:startle', { bubbles: true, detail: { x, y } }));
    });

    // On wide screens the page scrolls inside .page-wrapper, and a viewport-rooted observer clips at that scroller,
    // which cancels its margins; rooting at the scroller keeps them.
    const scroller = this.closest('.page-wrapper');
    const root = scroller && getComputedStyle(scroller).overflowY !== 'visible' ? scroller : null;

    const drop = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        drop.disconnect();
        this.dataset.state = 'drop';
      },
      { root, rootMargin: '0px 0px -12% 0px' }
    );
    // Arming while the sign is already on screen would make it jump up, so a sign seen at load stays down.
    const arm = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        arm.disconnect();
        if (entry.boundingClientRect.top < (root ? root.getBoundingClientRect().bottom : innerHeight)) return;
        this.dataset.state = 'armed';
        drop.observe(impact);
      },
      { root, rootMargin: '0px 0px 100% 0px' }
    );
    arm.observe(stage);
  }
}

if (!customElements.get('bc-crash')) customElements.define('bc-crash', BcCrash);
